module.exports = __webpack_public_path__ + "assets/65ad7e54c63c162fef9170df8b178e51.jpg";